import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

export default function FloatingButtons() {
    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
            {/* WhatsApp Floating Button */}
            <a
                href="https://wa.me/919911992162"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 md:w-14 md:h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-transform hover:scale-110 cursor-pointer"
                title="Chat on WhatsApp"
            >
                <MessageCircle size={26} className="md:w-7 md:h-7" />
            </a>

            {/* Call Floating Button */}
            <a
                href="tel:+919911992162"
                className="w-12 h-12 md:w-14 md:h-14 bg-orange-600 hover:bg-orange-700 text-white rounded-full shadow-lg flex items-center justify-center transition-transform hover:scale-110 cursor-pointer"
                title="Call Us"
            >
                <Phone size={24} className="md:w-6 md:h-6" />
            </a>
        </div>
    );
}